import { List, ListProps } from '@mui/material';
import { PropsWithChildren } from 'react';

const DotList = ({ children, sx, ...props }: PropsWithChildren<ListProps>) => {
  return (
    <List
      disablePadding={true}
      {...props}
      sx={{
        listStyleType: '"• "',
        listStylePosition: 'inside',
        ...sx,
      }}
    >
      {children}
    </List>
  );
};

export default DotList;
